import {
  BEARER_INVALID,
  TOKEN_STORE_KEY,
  USER_NAME,
  USER_ROLE,
  PROVINCIA,
  CANTON,
  DISTRITO,
} from "./constants";

function getToken() {
  const token = sessionStorage.getItem(TOKEN_STORE_KEY);
  return token ? token : BEARER_INVALID;
}

function setToken(token) {
  sessionStorage.setItem(TOKEN_STORE_KEY, token);
}

function eraseToken() {
  sessionStorage.removeItem(TOKEN_STORE_KEY);
}

function setUserName(userName) {
  sessionStorage.setItem(USER_NAME, userName);
}

function getUserName() {
  return sessionStorage.getItem(USER_NAME);
}


function setUserRole(userRole) {
  sessionStorage.setItem(USER_ROLE, userRole);
}

function getUserRole() {
  return sessionStorage.getItem(USER_ROLE);
}

function setProvincia(provincia) {
  sessionStorage.setItem(PROVINCIA, provincia);
}

function getProvincia() {
  return sessionStorage.getItem(PROVINCIA);
}

function setCanton(canton) {
  sessionStorage.setItem(CANTON, canton);
}

function getCanton() {
  return sessionStorage.getItem(CANTON);
}

function setDistrito(distrito) {
  sessionStorage.setItem(DISTRITO, distrito);
}

function getDistrito() {
  return sessionStorage.getItem(DISTRITO);
}

export {
  getToken,
  setToken,
  eraseToken,
  setUserName,
  getUserName,
  setUserRole,
  getUserRole,
  setProvincia,
  getProvincia,
  setCanton,
  getCanton,
  setDistrito,
  getDistrito,
};
